import { Controller, useFormContext } from 'react-hook-form';
import { format } from 'date-fns';

import { DateTimeInput } from '@ui/components/DateTimeInput';
import { Dropdown } from '@ui/components/Dropdown';
import { FormInput, FormLabel, FormRow } from '@ui/components/Form/Form';

import { TournamentEditFormValues } from '@features/tournament/ui/components/TournamentSettings/typings';

import styles from './TournamentEditFormInputs.module.css';

const promoDropdownOptions = [
  { value: 'None', label: 'Без промо в клубе' },
  { value: 'Pinned', label: 'Закрепленный в списке' },
  { value: 'Promoted', label: 'Подсвеченый в списке' },
];

export function StartTimeInput() {
  const { control } = useFormContext<TournamentEditFormValues>();
  return (
    <FormRow>
      <FormLabel>Дата и время</FormLabel>

      <FormInput>
        <Controller
          name="startTime"
          control={control}
          render={({ field: { value, onChange, disabled } }) => (
            <DateTimeInput
              className={styles.dateTimeInput}
              invisible
              onChange={onChange}
              value={value}
              disabled={disabled}
              min={format(new Date(), 'yyyy-MM-dd')}
            />
          )}
        />
        <Controller
          name="highlight"
          control={control}
          render={({ field: { value, onChange, disabled } }) => {
            const onValidChange = (value: string) => {
              onChange(value);
            };
            return (
              <Dropdown
                className={styles.promotedInput}
                options={promoDropdownOptions}
                value={value}
                onChange={onValidChange}
                disabled={disabled}
              />
            );
          }}
        />
      </FormInput>
    </FormRow>
  );
}
